import { writable } from "svelte/store"
import { curPathStr } from "./util.ts"

export const curPath = writable(curPathStr())

export const resetPath = () => curPath.set(curPathStr())
